import { Spin } from 'antd';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import lazyWithRetry from './lazyWithRetry';
const Notifications = lazyWithRetry(() => import('../pages/Dashboard/Settings/Notifications'));
const Claim = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/Claim'));
const MemberClaimDetails = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/ClaimDetails'));
const ClaimsAnalytics = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/ClaimsAnalytics'));
const Communication = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/Communication'));
const Documents = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/Documents'));
const TreatmentDetails = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/TreatmentDetails'));
const ViewClaim = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/ViewClaim'));
const AddTransactionDetails = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/PoliciesAndProducts/AddTransaction/AddTransactionDetails'));
const PlanListing = lazyWithRetry(() => import('../pages/Dashboard/Products/Details/PlanListing'));
const Settings = lazyWithRetry(() => import('../pages/Dashboard/Settings/Settings'));
const UpdateOffersAndPlans = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/OffersAndPlans/UpdateOffersAndPlans'));
const ListOffersAndPlans = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/OffersAndPlans/ListOffersAndPlans'));
const OffersAndPlans = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/OffersAndPlans/OffersAndPlans'));
const PartnerOffersAndPlans = lazyWithRetry(() => import('../pages/Dashboard/PartnerManager/OffersAndPlans/PartnerOffersAndPlans'));
const AgentOffersAndPlans = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AgentOffersAndPlans'));
const OffersAndPlansSection = lazyWithRetry(() => import('../pages/Dashboard/OffersAndPlans/OffersAndPlansSection'));
const EcardSendTool = lazyWithRetry(() => import('../pages/Dashboard/Ecard/EcardSendTool'));
const ManageProduct = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/PoliciesAndProducts/ManageProduct'));
const AddClaimWithIntimation = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/AddClaimWithIntimation/AddClaimWithIntimation'));
const ClaimLogs = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/ClaimLogs'));
const IntimationDetails = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/IntimationDetails'));
const ClientManager = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/ClientManager'));
const AddUpdatePlan = lazyWithRetry(() => import('../pages/Dashboard/Products/Details/AddUpdatePlan'));
const ClaimsProcessorDocuments = lazyWithRetry(
  () => import('../pages/Dashboard/ClaimsManager/ClaimsProcessorDocuments')
);
const Finance = lazyWithRetry(() => import('../pages/Dashboard/Finance/Finance'));
const UploadTxMIS = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/UploadData/UploadTxMIS')
);
const Transactions = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/Transactions/Transactions')
);
const AgentUserManagement = lazyWithRetry(
  () => import('../pages/Dashboard/AgentManager/AddAgent/UserManagement/AgentUserManagement')
);
const AgentAddUser = lazyWithRetry(
  () => import('../pages/Dashboard/AgentManager/AddAgent/UserManagement/User/AgentAddUser')
);
const AddAgent = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AddAgent'));
const AgentConfigAddition = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AgentConfigAddition'));
const AgentConfig = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AgentConfig'));
const AgentFeatures = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AgentFeatures'));
const AgentDetails = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AgentDetails'));
const AgentProductsAddition = lazyWithRetry(
  () => import('../pages/Dashboard/AgentManager/AddAgent/AgentProductsAddition')
);
const AgentProducts = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AddAgent/AgentProducts'));
const ProductListing = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/Products/ProductListing'));
const AgentManager = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AgentManager'));
const ViewAgent = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/ViewAgent'));
const IndividualMemberAddition = lazyWithRetry(
  () =>
    import(
      '../pages/Dashboard/ClientManager/Corporate/ViewClient/MemberManager/AddMember/Individual/IndividualMemberAddition'
    )
);
const ClaimsListing = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/ClaimsListing'));
const AgentListing = lazyWithRetry(() => import('../pages/Dashboard/AgentManager/AgentListing'));
const ClientMemberSubs = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/PoliciesAndProducts/ClientMemberSubs')
);
const ClientCustomisation = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/Customisation/ClientCustomisation')
);
const CorporateClientListing = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ClientList/ClientList')
);
const IndividualClientListing = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/ClientList/ClientList')
);
const PartnerListing = lazyWithRetry(() => import('../pages/Dashboard/PartnerManager/PartnerList/PartnerList'));
const ClientMemberCommunication = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/CommunicationManager/ClientMemberCommunication')
);
const CommunicationManagement = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/CommunicationManager/CommunicationManagement')
);
const PartnerPoliciesAndProducts = lazyWithRetry(
  () => import('../pages/Dashboard/PartnerManager/PoliciesAndProducts/PoliciesAndProducts')
);
const ViewPartner = lazyWithRetry(() => import('../pages/Dashboard/PartnerManager/ViewPartner/ViewPartner'));
const PartnerManager = lazyWithRetry(() => import('../pages/Dashboard/PartnerManager/PartnerManager'));
const OfferManager = lazyWithRetry(() => import('../pages/Dashboard/OfferManager/OfferManager'));
const AssignOffers = lazyWithRetry(() => import('../pages/Dashboard/OfferManager/AssignOffers'));
const AddOffers = lazyWithRetry(() => import('../pages/Dashboard/OfferManager/AddOffers/AddOffers'));
const OfferList = lazyWithRetry(() => import('../pages/Dashboard/OfferManager/OfferList/OfferList'));
const OfferListingForBroker = lazyWithRetry(() => import('../pages/Dashboard/OfferManager/OfferList/ForBrokers'));
const AddIndividualClientProduct = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/PoliciesAndProducts/AddIndividualClientProduct')
);
const AddIndividual = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/AddIndividual/AddIndividual')
);
const IndividualMemberDetails = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/AddIndividual/MemberDetails')
);
const IndividualProductDetails = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/AddIndividual/ProductDetails')
);
const ResetPassword = lazyWithRetry(() => import('../pages/Login/SetPassword/ResetPassword'));
const CouponManagement = lazyWithRetry(
  () => import('../pages/Dashboard/Products/Details/CouponManagement/CouponManagement')
);
const Unauthorized = lazyWithRetry(() => import('../pages/Dashboard/Unauthorized'));
const Maintenance = lazyWithRetry(() => import('../pages/Maintenance'));
const FiveHundred = lazyWithRetry(() => import('../pages/FiveHundred'));
const SetPassword = lazyWithRetry(() => import('../pages/Login/SetPassword/SetPassword'));
const AddProducts = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/AddProducts/AddProducts')
);
const LinkOffers = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/ORPPartner/LinkOffers')
);
const UploadData = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/UploadData/UploadData')
);
const ClientDetails = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/ClientDetails/ClientDetails')
);
const PartnerDetails = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/ORPPartner/PartnerDetails')
);
const ProductBenefits = lazyWithRetry(() => import('../pages/Dashboard/Products/Details/ProductBenefits'));
const AddProductBenefits = lazyWithRetry(() => import('../pages/Dashboard/Products/Details/AddProductBenefits'));
const TPA = lazyWithRetry(() => import('../pages/Dashboard/Products/TPA/TPA'));
const ViewClient = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/ViewClient'));
const ViewIndividualClient = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/ViewClient/ViewClient')
);
const MemberManagement = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/MemberManager/MemberManagement')
);
const AddMember = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/MemberManager/AddMember/AddMember')
);
const AddIndividualMember = lazyWithRetry(
  () =>
    import(
      '../pages/Dashboard/ClientManager/Corporate/ViewClient/MemberManager/AddMember/Individual/MemberDetails/AddIndividualMember'
    )
);
const ClientSettings = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/ClientFeatures/ClientSettings')
);

// Protected
const Dashboard = lazyWithRetry(() => import('../pages/Dashboard/Dashboard/Dashboard'));
const CorporateClientManager = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/CorporateClientManager')
);
const IndividualClientManager = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/IndividualClientManager')
);
const ProviderListing = lazyWithRetry(() => import('../pages/Dashboard/Providers/ProviderListing'));
const Providers = lazyWithRetry(() => import('../pages/Dashboard/Providers/Provider'));
const Provider = lazyWithRetry(() => import('../pages/Dashboard/Providers/Provider/Provider'));
const AddProduct = lazyWithRetry(() => import('../pages/Dashboard/Providers/Provider/AddProduct'));
const AddProvider = lazyWithRetry(() => import('../pages/Dashboard/Providers/AddProvider'));
const Products = lazyWithRetry(() => import('../pages/Dashboard/Products/Details/Products'));
const ClaimsManager = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/ClaimsManager'));
const IndividualClaimsManager = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/IndividualClaimsManager'));
const ClaimDetails = lazyWithRetry(() => import('../pages/Dashboard/ClaimsManager/AddClaim/ClaimDetails'));
const UserManagement = lazyWithRetry(() => import('../pages/Dashboard/UserManagement/UserManagement'));
const MainSettings = lazyWithRetry(() => import('../pages/Dashboard/MainSettings/MainSettings'));
const BannerListing = lazyWithRetry(() => import('../pages/Dashboard/MainSettings/Tools/Banner/BannerListing'));
const BannerForm = lazyWithRetry(() => import('../pages/Dashboard/MainSettings/Tools/Banner/BannerForm'));
const PoliciesAndProducts = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/PoliciesAndProducts/PoliciesAndProducts')
);
const IndividualPoliciesAndProducts = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Individual/PoliciesAndProducts/PoliciesAndProducts')
);

const AddRole = lazyWithRetry(() => import('../pages/Dashboard/UserManagement/Role/AddRole'));
const AddUser = lazyWithRetry(() => import('../pages/Dashboard/UserManagement/User/AddUser'));
const AddEntity = lazyWithRetry(() => import('../pages/Dashboard/ClientManager/Corporate/AddClient/AddClient'));
const ProductDetails = lazyWithRetry(
  () =>
    import(
      '../pages/Dashboard/ClientManager/Corporate/ViewClient/MemberManager/AddMember/Individual/ProductDetails/ProductDetails'
    )
);
const ReviewMemberData = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/ViewClient/MemberManager/AddMember/Bulk/ReviewMemberData')
);
const ReviewScreen = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/ReviewData/ReviewScreen')
);
const ReviewTxMemberData = lazyWithRetry(
  () => import('../pages/Dashboard/ClientManager/Corporate/AddClient/ReviewData/ReviewTxMemberData')
);

// Public
const LoginScreen = lazyWithRetry(() => import('../pages/Login/LoginScreen/LoginScreen'));
const ForgotPassword = lazyWithRetry(() => import('../pages/Login/ForgotPassword/ForgotPassword'));
const LoginViaOTP = lazyWithRetry(() => import('../pages/Login/LoginViaOTP/LoginViaOTP'));

const Router: React.FC = () => {
  const isAuthenticated = useSelector((state: any) => state.auth.isLoggedIn),
    controls = useSelector((state: any) => state.auth.controls),
    maintenanceRoutes = <>
      <Route path="/maintenance" element={<Maintenance />} />
      <Route path="/500" element={<FiveHundred />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="*" element={<Navigate to="/" />} />
    </>;

  if (Object.keys(controls).length === 0) {
    return (
      <div className="loader-div" style={{ height: '200px' }}>
        <div className="loader">
          <Spin size="large"></Spin>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Suspense
        fallback={
          <div className='loader-div'>
            <div className="loader">
              <Spin size="large"></Spin>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route path="login" element={<Navigate to="/" />} />
          <Route path="signin" element={<Navigate to="/" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/login-via-otp" element={<LoginViaOTP />} />
          {maintenanceRoutes}
        </Routes>
      </Suspense>
    )
  }

  if (controls?.is_admin) {
    return (
      <Suspense
        fallback={
          <div className='loader-div'>
            <div className="loader">
              <Spin size="large"></Spin>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Navigate to="/agent-manager" />} />
          <Route path="/agent-manager/*" element={<AgentManager />}>
            <Route path="" element={<AgentListing />} />
            <Route path="add-agent/" element={<AddAgent />}>
              <Route path="" element={<AgentDetails />} />
              <Route path=":uuid" element={<AgentDetails />} />
              <Route path=":uuid/products/" element={<AgentProductsAddition />} />
              <Route path=":uuid/configuration" element={<AgentConfigAddition />} />
            </Route>
            <Route path=":uuid" element={<ViewAgent />} />
            <Route path=":uuid/manage-products" element={<AgentProducts />} />
            <Route path=":uuid/offers-and-plans" element={<AgentOffersAndPlans />}>
              <Route path='' element={<ListOffersAndPlans />} />
              <Route path="update" element={<UpdateOffersAndPlans />} />
            </Route>
            <Route path=":uuid/customisation" element={<AgentConfig />} />
            <Route path=":uuid/settings" element={<AgentFeatures />} />
            <Route path=":uuid/admin-management">
              <Route path="" element={<AgentUserManagement />} />
              <Route path="add-admin" element={<AgentAddUser />} />
            </Route>
          </Route>

          <Route path="/offers/*" element={<OfferManager />}>
            <Route path="" element={<OfferList />} />
            <Route path=":uuid" element={<AddOffers />} />
            <Route path="add-offers" element={<AddOffers />} />
          </Route>

          <Route path="/providers/*" element={<Providers />}>
            <Route path="" element={<ProviderListing />} />
            <Route path=":providerid" element={<Provider />} />
            <Route path=":providerid/add" element={<AddProduct />} />
            <Route path="add" element={<AddProvider />} />
          </Route>

          <Route path="/products" element={<Products />}>
            <Route path="" element={<ProductListing interactive={true} />} />
            <Route path="benefits/:productid" element={<ProductBenefits />} />
            <Route path="benefits/:productid/add" element={<AddProductBenefits />} />
            <Route path=":productid/plans" element={<PlanListing />} />
            <Route path=":productid/plans/add" element={<AddUpdatePlan />} />
            <Route path=":productid/plans/update/:uuid" element={<AddUpdatePlan />} />
            <Route path=':productid/plans/:planid' element={<CouponManagement />} />
            {/* <Route path=":providerid/coupons/:productid" element={<CouponManagement />} /> */}
          </Route>

          <Route path="/tpa-Master" element={<TPA />} />

          <Route path="/user-management/*">
            <Route path="" element={<UserManagement />} />
            <Route path="add-user" element={<AddUser />} />
            <Route path="add-role" element={<AddRole />} />
          </Route>

          <Route path="/settings">
            <Route path="" element={<MainSettings />} />
            <Route path="e-card" element={<EcardSendTool />} />
            <Route path="add-user" element={<AddUser />} />
            <Route path="add-role" element={<AddRole />} />
          </Route>

          <Route path="/orp-partners/*" element={<PartnerManager />}>
            <Route path="" element={<PartnerListing />} />
            <Route path=":id" element={<ViewPartner />} />
            <Route path=":id/offers-and-plans" element={<PartnerOffersAndPlans pageIntent="orp-partner" />}>
              <Route path="" element={<ListOffersAndPlans />} />
              <Route path="update" element={<LinkOffers />} />
            </Route>
            <Route path="add-partner/*" element={<AddEntity />}>
              <Route path="" element={<PartnerDetails pageIntent="orp-partner" />} />
              <Route path=":id/add" element={<LinkOffers pageIntent="orp-partner" existing={false} />} />
              <Route path=":id" element={<PartnerDetails pageIntent="orp-partner" />} />
            </Route>
          </Route>

          <Route path="/settings" element={<Settings />} />

          {maintenanceRoutes}
        </Routes>
      </Suspense>
    )
  }

  return (
    <Suspense
      fallback={
        <div className="loader-div">
          <div className="loader">
            <Spin size="large"></Spin>
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/home" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reports" element={<Finance />} />
        <Route path="/configuration" element={<Settings />} />
        <Route path="/client-manager/*">
          <Route path="" element={<Navigate to={'corporate'} />} />
          <Route path="corporate/*" element={<CorporateClientManager />}>
            <Route path="" element={<ClientManager tab="corporate" />} />
            <Route path=":id" element={<ViewClient />} />
            <Route path=":id/offers-and-plans" element={<OffersAndPlans />}>
              <Route path="" element={<ListOffersAndPlans />} />
              <Route path="update" element={<UpdateOffersAndPlans />} />
            </Route>
            <Route path=":id/customisation" element={<ClientCustomisation />} />
            {/* <Route path=":id/add-products" element={<AddProducts from="view-section" pageIntent="add-client" intent="add-product" existing={false} />} /> */}
            <Route path=":id/add-products" element={<AddTransactionDetails transaction_only={false} />} />
            <Route path=":id/add-members">
              <Route path="" element={<AddMember from="view-section" />} />
              <Route path="individual/*" element={<IndividualMemberAddition />}>
                <Route path="" element={<AddIndividualMember from="view-section" />} />
                <Route path="products" element={<ProductDetails />} />
              </Route>
              <Route path="bulk" element={<ReviewMemberData intent="add" />} />
            </Route>
            <Route path=":id/settings">
              <Route path="" element={<ClientSettings />} />
              <Route path="transactions/*">
                <Route path="" element={<UploadTxMIS />} />
                <Route path="review" element={<ReviewTxMemberData />} />
                <Route path="products" element={<UploadTxMIS />} />
              </Route>
            </Route>
            <Route path=":id/member-manager" element={<MemberManagement />} />
            <Route path=":id/policies-and-products" element={<PoliciesAndProducts />} />
            <Route path=":id/policies-and-products/:type/:productid" element={<ManageProduct />} />
            <Route
              path=":id/policies-and-products/add-transaction-details"
              element={<AddTransactionDetails transaction_only={true} />}
            />
            <Route path=":id/communication" element={<CommunicationManagement />} />
            <Route path=":id/communication/:channel/:product_id" element={<ClientMemberCommunication />} />
            <Route path=":id/policies-and-products/:productid/benefits" element={<ProductBenefits />} />
            <Route path=":id/policies-and-products/:productid/:type/transactions" element={<Transactions />} />
            <Route path=":id/policies-and-products/:productid/subscriptions" element={<ClientMemberSubs />} />
            <Route path=":id/member-manager/add" element={<AddMember />} />
            <Route path=":id/member-manager/add/individual/*" element={<IndividualMemberAddition />}>
              <Route path="" element={<AddIndividualMember />} />
              <Route path="products" element={<ProductDetails />} />
            </Route>
            <Route path=":id/member-manager/add/bulk" element={<ReviewMemberData intent="add" />} />
            <Route path=":id/member-manager/modify" element={<UploadData intent="MODIFICATION" />} />
            <Route path=":id/member-manager/modify-endorsements" element={<UploadData type="endorsement" />} />
            <Route
              path=":id/member-manager/modify-endorsements/review"
              element={<ReviewMemberData type="endorsement" />}
            />
            <Route path=":id/member-manager/modify/review" element={<ReviewMemberData intent="modify" />} />
            <Route path=":id/member-manager/delete" element={<UploadData intent="DELETION" />} />
            <Route path=":id/member-manager/delete/review" element={<ReviewMemberData intent="delete" />} />
            <Route path=":id/member-manager/assign-products" element={<UploadData intent="assign" />} />
            <Route path=":id/member-manager/assign-products/review" element={<ReviewMemberData intent="assign" />} />
            <Route
              path=":id/policies-and-products/add"
              element={<AddProducts pageIntent="add-client" intent="add-product" existing />}
            />
            <Route path="add-client/*" element={<AddEntity />}>
              <Route path="" element={<ClientDetails pageIntent="add-client" />} />
              <Route
                path=":id/products"
                element={<AddProducts pageIntent="add-client" intent="add-client" existing={false} />}
              />
              <Route path=":id" element={<ClientDetails pageIntent="add-client" />} />
              <Route
                path=":id/products/:saleid"
                element={<AddProducts pageIntent="add-client" intent="add-client" existing={true} />}
              />
              <Route path=":id/products/:saleid/upload" element={<UploadData intent="ADDITION" />} />
              <Route path=":id/products/:saleid/upload/review" element={<ReviewScreen />} />
            </Route>

            <Route path=":id/claims-manager/*">
              <Route path="" element={<ClaimsListing />} />
              <Route path="add-claim" element={<AddClaimWithIntimation />} />
              <Route path="analytics" element={<ClaimsAnalytics />} />
              <Route path="view-claim/:claimid/*" element={<Claim />}>
                <Route path="" element={<ViewClaim />} />
                <Route path="treatment-details" element={<TreatmentDetails />} />
                <Route path="intimation-details" element={<IntimationDetails />} />
                <Route path="claim-logs" element={<ClaimLogs />} />
                <Route path="claim-details" element={<MemberClaimDetails />} />
                <Route path="documents" element={<Documents />} />
                <Route path="communication" element={<Communication />} />
              </Route>
            </Route>
          </Route>

          <Route path="individual/*" element={<IndividualClientManager />}>
            <Route path="" element={<ClientManager tab="individual" />} />
            <Route path="add-member/*" element={<AddIndividual />}>
              <Route path="" element={<IndividualMemberDetails />} />
              <Route path="product/:id" element={<IndividualProductDetails />} />
            </Route>
            <Route path=":id" element={<ViewIndividualClient />} />
            <Route path=":id/edit" element={<IndividualClientManager />} />
            <Route path=":id/policies-and-products/*">
              <Route path="" element={<IndividualPoliciesAndProducts />} />
              <Route path="add" element={<AddIndividualClientProduct />} />
            </Route>
            <Route path=":id/claims-manager/*">
              <Route path="" element={<IndividualClaimsManager />} />
              {/* <Route path="add-claim" element={<IndividualClaimsManager />} /> */}
              <Route path="add-claim" element={<ClaimDetails />} />
              <Route path="view-claim/:claimid/*" element={<Claim />}>
                <Route path="" element={<ViewClaim />} />
                <Route path="treatment-details" element={<TreatmentDetails />} />
                <Route path="claim-details" element={<MemberClaimDetails />} />
                <Route path="documents" element={<Documents />} />
                <Route path="communication" element={<Communication />} />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path="/claims-manager/*" element={<ClaimsManager />}>
          <Route path="" element={<ClaimsListing />} />
          <Route path=":id" element={<ClaimsListing />} />
          <Route path="add-claim" element={<AddClaimWithIntimation />} />
          <Route path=":id/add-claim" element={<AddClaimWithIntimation />} />
          {/* <Route path=":id/add-claim" element={<ClaimDetails />} /> */}
          <Route path="view-claim/:claimid/*" element={<Claim />}>
            <Route path="" element={<ViewClaim />} />
            <Route path="treatment-details" element={<TreatmentDetails />} />
            <Route path="claim-logs" element={<ClaimLogs />} />
            <Route path="intimation-details" element={<IntimationDetails />} />
            <Route path="claim-details" element={<MemberClaimDetails />} />
            <Route path="documents" element={<Documents />} />
            <Route path="communication" element={<Communication />} />
          </Route>
        </Route>
        <Route path="/user-management/*">
          <Route path="" element={<UserManagement />} />
          <Route path="add-user" element={<AddUser />} />
          <Route path="add-role" element={<AddRole />} />
        </Route>
        <Route path="/settings">
          <Route path="" element={<MainSettings />} />
          <Route path="custom-banners" element={<BannerListing />} />
          <Route path="custom-banners/create" element={<BannerForm />} />
          <Route path="custom-banners/edit/:id" element={<BannerForm />} />
          {/* <Route path="user-management/*" element={<UserManagement />} /> */}
          <Route path="add-user" element={<AddUser />} />
          <Route path="add-role" element={<AddRole />} />
        </Route>
        <Route path="/offers-and-plans/*" element={<OffersAndPlansSection />} />
        <Route path="/products" element={<ProductListing interactive={false} />} />
        <Route path="/notification-settings" element={<Notifications />} />
        {maintenanceRoutes}
      </Routes>
    </Suspense>
  );
};

export default Router;
